/** How many next steps a status lists under its line; the rest are counted and left to its detail. */
export const NEXT_STEPS_LIMIT = 3
